import { isAxiosError } from "axios"
import { ImportWarning } from "types/dataImport.types"
import { parseImportWarnings } from "features/DataImport/utils/parseImportWarnings"

/** How the Conductor's /datafile-combine starts its 400 when no question could be imported. */
export const NOTHING_IMPORTED_PREFIX = "The data could not be imported. "

/**
 * The import warnings behind a "nothing was imported" answer, or null for any other error.
 *
 * The Conductor follows the prefix with the engine's newline-joined import warnings. They are
 * read from the whole response body, not serverMessageOf's shortened one: the `[unmapped]`
 * inventory alone can run to tens of KB, and a cut would break the JSON the import results
 * panel reads. Null too when nothing follows the prefix, so the caller shows the bare message.
 */
export const nothingImportedWarningsOf = (error: unknown): ImportWarning[] | null => {
  if (!isAxiosError(error)) return null
  const data: unknown = error.response?.data
  if (typeof data !== "string" || !data.startsWith(NOTHING_IMPORTED_PREFIX)) return null
  const warnings = parseImportWarnings(data.slice(NOTHING_IMPORTED_PREFIX.length))
  return warnings.length > 0 ? warnings : null
}
